import Cookies from "js-cookie";
import { isCrawlerUserAgent } from "is-web-crawler";

class Disclaimer {
  static initEvents() {
    document.addEventListener("DOMContentLoaded", Disclaimer.initDisclaimer);
  }

  static initDisclaimer() {
    if (isCrawlerUserAgent()) {
      return;
    }

    if (Disclaimer.getDismissedCookie() === "true") {
      return;
    }

    const modal = document.getElementById("modal-disclaimer");
    const form = document.getElementById("form-disclaimer");

    if (modal === null) throw new Error("Modal element not found");
    if (form === null) throw new Error("Form element not found");

    const showCheckboxError = () => {
      const error = document.querySelector("#disclaimer_confirmation_error");
      if (error === null) {
        throw new Error("Checkbox error element not found");
      }

      error.classList.toggle("show", true);
    };

    form.addEventListener("submit", (event) => {
      event.preventDefault();

      // Check that confirmation checkbox is checked
      const checkbox = form.querySelector<HTMLInputElement>("#disclaimer_confirmation");
      const isChecked = checkbox?.checked ?? false;

      if (!isChecked) {
        showCheckboxError();
        return;
      }

      Disclaimer.setDismissedCookie();
      modal.removeAttribute("open");
    });
    modal.setAttribute("open", "true");
  }

  static getDismissedCookie() {
    return Cookies.get("disclaimer_dismissed");
  }

  static setDismissedCookie(value = "true") {
    Cookies.set("disclaimer_dismissed", value, { expires: 7 });
  }
}

Disclaimer.initEvents();
